// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2UWhz","empty":"ModalGraph_empty__2gDXR"};